export const POST_PAGE_RESIZE = 'postPage/RESIZE';

export const postPageResized = (payload: {
  viewMode: unknown;
  width: number;
  buildertype: string;
}) => ({
  type: POST_PAGE_RESIZE,
  payload,
  meta: { debounce: 2000 },
});
